export default "__VITE_ASSET__02852ca5__"